import { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { GET_MASTER_LIST } from "../../Apis/home_api";
import CircularProgress from "@mui/material/CircularProgress";

function TermsService() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const getData = async () => {
    const res = await GET_MASTER_LIST();
    if (res && res.s) {
      setData(res.r);
    }
    setLoading(false);
  };

  const getValue = (id) => {
    const specificObject = data.find((item) => item.id === id);
    return specificObject ? specificObject.value : "";
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  return (
    <>
      {loading ? (
        <Box
          width="100%"
          height="80vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress disableShrink />
        </Box>
      ) : (
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          pt="3rem"
        >
          <Stack width={["92%", "92%", "86%", "86%", "86%"]} gap="3rem">
            <Typography
              variant="h3"
              fontSize={["30px", "30px", "54px", "54px", "54px"]}
              textAlign="center"
            >
              {getValue(49)}
            </Typography>

            <Stack width={["98%", "100%", "98%", "90%", "85%"]} m="auto">
              <div
                dangerouslySetInnerHTML={{ __html: getValue(50) }}
                style={{
                  width: "97%",
                  margin: "auto",
                  paddingBottom: "1rem",
                }}
              />
            </Stack>
          </Stack>
        </Box>
      )}
    </>
  );
}

export default TermsService;
